import React from "react"

const ArrowRightSvg = (props) => {
  return (
    <svg viewBox="0 0 17 28" {...props}>
      <defs>
        <path
          id="prefix__a"
          d="M8.333 145l-1.126 1.115L-5 158.006-2.748 161l11.081-10.797L19.414 161l2.253-2.994L9.46 146.115z"
        />
      </defs>
      <use
        transform="rotate(90 77.833 83.5)"
        xlinkHref="#prefix__a"
        fillRule="evenodd"
      />
    </svg>
  )
}

export default ArrowRightSvg
